import Vue from "vue";
import api from "../ApiBase";

export default {
	/**
	 * 
	 * @returns {object[]} partner
	 */
	async getPartner() {
		try {
			Vue.$log.debug("Get Partner");
			const response = await api.get("GetEchtPartnerParents");
			if (!response || !response.data) {
				Vue.$log.error("No data received from GetPartner");
				return null;
			}
			return response.data;
		} catch (error) {
			Vue.$log.error("Error in getPartner: " + error);
			return null;
		}
	},
	/**
	 * @param {number} id
	 * @returns {object} partner
	 */
	async getEchtPartnerById(id) {
		try {
			Vue.$log.debug("Get EchtPartner by ID: " + id);
			const response = await api.get("GetEchtPartner?PartnerID=" + id);
			return response.data;
		} catch (error) {
			Vue.$log.error("Error in getEchtPartnerById: " + error);
			return null;
		}
	},
	/**
	 * @param {number} id
	 * @returns {object} partner parent
	 */
	async getEchtPartnerDetailsById(id) {
		try {
			Vue.$log.debug("Get EchtPartnerDetails by ID: " + id);
			let response = await api.get("GetEchtPartnerDetails?PartnerID=" + id);
			return response.data;
		} catch (error) {
			Vue.$log.error("Error in getEchtPartnerDetailsById: " + error);
			return null;
		}
	},
	/**
	 * @param {number} id
	 * @param {object} partner
	 * @returns {object} partner
	 */
	async updateEchtPartnerById(id, partner) {
		try {
			Vue.$log.debug(
				"Update EchtPartner by ID: " +
				id +
				" with data: " +
				JSON.stringify(partner)
			);
			return await api.post("UpdateEchtPartner?PartnerID=" + id, partner);
		} catch (error) {
			Vue.$log.error("Error in updateEchtPartnerById: " + error);
			return null;
		}
	},
	/**
	 * @param {number} id
	 * @returns {object} partner
	 */
	async getEchtPartnerChildsById(id) {
		try {
			Vue.$log.debug("Get EchtPartnerChilds by ID: " + id);
			let response = await api.get("/GetEchtPartnerChilds?parentId=" + id);
			return response.data;
		} catch (error) {
			Vue.$log.error("Error in getEchtPartnerChildsById: " + error);
			return null;
		}
	},
	/**
	 * @returns {object[]} partner
	 */
	async getSingleEchtPartnerParentsById() {
		try {
			Vue.$log.debug("Get Single EchtPartnerParents");
			let response = await api.get("/GetEchtPartnerSingleParents");
			return response.data;
		} catch (error) {
			Vue.$log.error("Error in getSingleEchtPartnerParentsById: " + error);
			return null;
		}
	},
	/**
	 * 
	 * @param {*} item 
	 * @returns {object} response
	 */
	async setEchtPartnerDirty(item) {
		try {
			Vue.$log.debug("Set EchtPartner Dirty for: " + item.short_name);
			if (!item || !item.ECHT_PARTNER_ID) { throw new Error("Invalid item or missing ECHT_PARTNER_ID") }
			let response = await api.patch('SetEchtPartnerDirty?partnerId=' + item.ECHT_PARTNER_ID);
			Vue.$log.info(`Confirmation of ${item.short_name} successful`);
			return response.data;
		} catch (error) {
			Vue.$log.error(`Error confirming ${item.short_name}: ${error}`);
			return null;
		}
	},

	/**
	 * @param {number} parent
	 * @param {number[]} children
	 * @returns {object} response
	 */
	async addEchtPartnerChildToParent(parent, children) {
		try {
			Vue.$log.debug("Add EchtPartner Child to Parent");
			const response = await api.patch('AddEchtPartnerChildToParent?parentId=' + parent + '&childId=' + children);
			if (response.data !== 1) {
				Vue.$log.error(`Error adding child to parent with ID ${parent}`);
				return null;
			}
			Vue.$log.info(`Child added to parent with ID ${parent} successfully`);
			return response.data;
		} catch (error) {
			Vue.$log.error("Error in AddEchtPartnerChildToParent: " + error);
			return null;
		}
	},

	async splitPartner(item) {
		try {
			const response = await api.patch('RemoveEchtPartnerChildFromParent?childId=' + item.ECHT_PARTNER_ID);
			return response.data;
		} catch (error) {
			Vue.$log.error("Error in splitPartner: " + error);
			return null;
		}
	}
};
